import { useEffect, useState } from "react";
import { uploadUrl } from "../../lib/assets";
import { masonryColumnCount, photoBackground } from "../../lib/photographyUtils";

/**
 * @param {{ collection: import("../../data/photography").Collection, onBack: () => void, onOpenLightbox: (list: import("../../data/photography").Photo[], index: number) => void }} props
 */
export default function CollectionDetail({ collection, onBack, onOpenLightbox }) {
  const [columns, setColumns] = useState(() => masonryColumnCount(window.innerWidth));

  useEffect(() => {
    const onResize = () => setColumns(masonryColumnCount(window.innerWidth));
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <div className="photo-collection-detail">
      <section
        className="photo-collection-detail__hero"
        style={{ background: photoBackground(collection.cover) }}
      >
        <div className="photo-collection-detail__hero-scrim" />
        <div className="photo-collection-detail__hero-content">
          <div className="photo-collection-detail__eyebrow">COLLECTION</div>
          <h1 className="photo-collection-detail__title">{collection.title}</h1>
          <div className="photo-collection-detail__meta">
            <span className="photo-collection-detail__subtitle">{collection.subtitle}</span>
            <span className="photo-collection-detail__count">· {collection.count} PHOTOGRAPHS</span>
          </div>
        </div>
      </section>

      <section className="photo-collection-detail__body">
        <button type="button" className="photo-collection-detail__back" onClick={onBack}>
          <span aria-hidden="true">←</span> ALL COLLECTIONS
        </button>

        <div
          className="photo-collection-detail__grid"
          style={{ columnCount: columns }}
        >
          {collection.photos.map((photo, index) => (
            <button
              key={`${photo.t}-${index}`}
              type="button"
              className="photo-masonry-tile"
              onClick={() => onOpenLightbox(collection.photos, index)}
            >
              {photo.src ? (
                <img src={uploadUrl(photo.src)} alt={photo.t} />
              ) : (
                <div
                  className="photo-masonry-tile__placeholder"
                  style={{
                    height: photo.h || 280,
                    background: photo.grad,
                  }}
                />
              )}
              <div className="photo-masonry-tile__overlay">
                <div className="photo-masonry-tile__title">{photo.t}</div>
                <div className="photo-masonry-tile__loc">
                  {photo.loc ? photo.loc.toUpperCase() : "VIEW FRAME"}
                </div>
              </div>
            </button>
          ))}
        </div>
      </section>
    </div>
  );
}
